/**
 * Created by Mark on 24/04/2017.
 */

import React  from 'react';
import Card from '../card.js';
import CardBody from '../card-body.js';
import CardHeader from '../card-header.js'
import {Nav , NavItem } from 'react-bootstrap';
import Panel from './panel.js';

export default class Profile extends React.Component {

    constructor(props){
        super();
        this.props = props;

        this.state ={
            panelIndex:props.panelIndex||0,
            sidePanel:props.sidePanel
        };

        this.handelTabSelect = this.handelTabSelect.bind(this);
    }

    handelTabSelect(panel){
        this.setState({panelIndex:panel})
    }

    componentWillReceiveProps(props){
        this.setState({sidePanel:props.sidePanel})
    }


    render(){

        const tabs = this.props.panels.map(function(tab , index){
            return <NavItem key={"panel-"+index} eventKey={index} >{tab.name}</NavItem>;
        });

        const panel     =  this.props.panels[this.state.panelIndex];
        const Component = React.createElement(Panel, {
            data:this.props.data,
            component:panel.component
        });

        return  <div className="card" id="profile-main">
                    <div className="pm-overview c-overflow">
                        {this.state.sidePanel()}
                    </div>
                    <div className="pm-body clearfix">
                        <Nav className="tab-nav p-0" activeKey={this.state.panelIndex} onSelect={this.handelTabSelect}>
                            {tabs}
                        </Nav>
                        {Component}
                    </div>
               </div>;

    }

}


// WEBPACK FOOTER //
// ./src/components/profile/profile.js